import $ from 'jquery';
import slick from 'slick-carousel';


export default () => {

    if ($("#form-booking-engine").length > 0) {
        $("#form-booking-engine").on('submit', function(event){
            event.preventDefault();

            var language = ICL_LANGUAGE_CODE == 'en' ? 1 : (
              ICL_LANGUAGE_CODE == 'it' ? 2 : (
                ICL_LANGUAGE_CODE == 'de' ? 3 : 1
              )
            );

            var datestart = $(this).find("#datestart").val();
            var dateend = $(this).find("#dateend").val();

            var splitDateStart = datestart.split('/');
            var splitDateEnd = dateend.split('/');

            if(ICL_LANGUAGE_CODE=='en') {
                datestart = splitDateStart[2] + splitDateStart[0] + splitDateStart[1];
                dateend = splitDateEnd[2] + splitDateEnd[0] + splitDateEnd[1];
            } else if (ICL_LANGUAGE_CODE=='it') {
                datestart = splitDateStart[2] + splitDateStart[1] + splitDateStart[0];
                dateend = splitDateEnd[2] + splitDateEnd[1] + splitDateEnd[0];
            } else if (ICL_LANGUAGE_CODE=='de') {
                datestart = splitDateStart[2] + splitDateStart[1] + splitDateStart[0];
                dateend = splitDateEnd[2] + splitDateEnd[1] + splitDateEnd[0];
            }

            var numberadults = $(this).find("#numberadults").val();
            var numberchildren = $(this).find("#numberchildren").val();

            var url = "https://book.hoodyhotel.com/#/hotel/2495/channel/1013/language/" + language + "/rooms?arrival=" + datestart + "&departure=" + dateend + "&adults=" + numberadults + "&childs=" + numberchildren;

            var win = window.open(url, '_blank');
            win.focus();

        });
    }

};



// WEBPACK FOOTER //
// ./scripts/libs/bookingEngine.js